// THIS VALUES ARE USED DURING CLIENT APP COMPILATION, PLEASE DO NOT MOVE
const initialAppId = 'app_pEjjREQ6nQjLJsxYKiftum'
const initialProjectId = 'proj_juiyewiKec'
// eslint-disable-next-line import/newline-after-import, @typescript-eslint/no-var-requires
const initialBuildOrdersOnApp = require('./buildOrders.loaded.json')
const initialRunningMode = 'premium'
const initialCustomFontName = undefined
// #################

export const initialAppState = {
    appId: initialAppId,
    projectId: initialProjectId,
    buildOrders: initialBuildOrdersOnApp,
    runningMode: initialRunningMode,
    customFontName: initialCustomFontName,
} as const
